import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';

import { CP_API_URL } from '../config/api';
import DefaultImage from "../assets/images/kempenDefault.jpg"
import './receipt.scss';

const STATUS_MAP = {
  Success: { label: 'Berjaya', variant: 'success', icon: 'fa-check' },
  Failed: { label: 'Gagal', variant: 'danger', icon: 'fa-times' },
  Pending: { label: 'Menunggu', variant: 'pending', icon: 'fa-clock' },
};

function Receipt() {
  const location = useLocation();
  const navigate = useNavigate();
  const [receipt, set_receipt] = useState(null);
  const [loading, setLoading] = useState(true);

  // Parse the query parameters from the URL
  const queryParams = new URLSearchParams(location.search);
  const orderId = queryParams.get('order_id');

  const GET__RECEIPT = async () => {
    setLoading(true);
    const requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    await fetch(`${CP_API_URL}/kempen/resit/${orderId}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log("Details Transaksi: ", result);
        set_receipt(result.data || null);
      })
      .catch((error) => {
        console.error(error);
        set_receipt(null);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (orderId) {
      GET__RECEIPT();
    } else {
      setLoading(false);
    }
  }, [orderId]);

  const handlePrint = () => {
    window.print();
  };

  if (loading) {
    return (
      <section className="receipt-section">
        <div className="tf-container">
          <div className="receipt-card receipt-skeleton">
            <div className="skeleton-circle" />
            <div className="skeleton-line" style={{ width: '55%', height: 20, margin: '0 auto 14px' }} />
            <div className="skeleton-line" style={{ width: '35%', margin: '0 auto 28px' }} />
            {Array.from({ length: 6 }).map((_, i) => (
              <div className="skeleton-line" key={i} style={{ width: '100%' }} />
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (!orderId || !receipt) {
    return (
      <section className="receipt-section">
        <div className="tf-container">
          <div className="receipt-card receipt-empty">
            <i className="fas fa-receipt"></i>
            <h5>Resit Tidak Dijumpai</h5>
            <p>Sila semak semula pautan resit anda atau hubungi institusi berkaitan.</p>
          </div>
        </div>
      </section>
    );
  }

  const status = STATUS_MAP[receipt.campTransStatus] || { label: receipt.campTransStatus, variant: 'default', icon: 'fa-info-circle' };

  return (
    <section className="receipt-section">
      <div className="tf-container">
        <div className="receipt-card">
          <div className={`receipt-status-icon receipt-status-icon--${status.variant}`}>
            <i className={`fas ${status.icon}`}></i>
          </div>

          <h3 className="receipt-title">
            {receipt.campTransStatus === 'Success' ? 'Terima Kasih Kerana Menyumbang' : `Transaksi ${status.label}`}
          </h3>

          <div className="receipt-amount">
            RM {parseFloat(receipt.campTransAmount || 0).toFixed(2)}
          </div>

          <span className={`receipt-badge receipt-badge--${status.variant}`}>
            <i className={`fas ${status.icon}`}></i>
            {status.label}
          </span>

          <div className="receipt-divider" />

          {(receipt.campaignTitle || receipt.campaignImage) && (
            <>
              <div className="receipt-campaign">
                <div className="receipt-campaign-media">
                  <img
                    src={receipt.campaignImage || DefaultImage}
                    alt={receipt.campaignTitle}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = DefaultImage;
                    }}
                  />
                </div>
                <div className="receipt-campaign-info">
                  <span className="receipt-campaign-label">Kempen Disumbang</span>
                  <p className="receipt-campaign-title">{receipt.campaignTitle || '-'}</p>
                  {receipt.campaignCode && <span className="receipt-campaign-code">{receipt.campaignCode}</span>}
                </div>
              </div>

              <div className="receipt-divider" />
            </>
          )}

          <div className="receipt-group">
            <h6 className="receipt-group-title">Maklumat Penyumbang</h6>
            <div className="receipt-row">
              <span className="receipt-label">Nama Penyumbang</span>
              <span className="receipt-value">{receipt.campTransPayerName || '-'}</span>
            </div>
            <div className="receipt-row">
              <span className="receipt-label">No. Telefon</span>
              <span className="receipt-value">{receipt.campTransPayerPhone || '-'}</span>
            </div>
            <div className="receipt-row">
              <span className="receipt-label">E-mel</span>
              <span className="receipt-value">{receipt.campTransPayerEmail || '-'}</span>
            </div>
          </div>

          <div className="receipt-divider" />

          <div className="receipt-group">
            <h6 className="receipt-group-title">Butiran Transaksi</h6>
            <div className="receipt-row">
              <span className="receipt-label">Tarikh Transaksi</span>
              <span className="receipt-value">{moment(receipt.campTransCreatedDate).format('DD MMM YYYY, h:mm A')}</span>
            </div>
            <div className="receipt-row">
              <span className="receipt-label">No. Rujukan</span>
              <span className="receipt-value receipt-value--mono">{receipt.campTransRefNo}</span>
            </div>
            <div className="receipt-row">
              <span className="receipt-label">Jenis Transaksi</span>
              <span className="receipt-value">{receipt.campTransPaymentChannel || '-'}</span>
            </div>
          </div>

          <div className="receipt-divider" />

          <div className="receipt-total-row">
            <span>Jumlah Sumbangan</span>
            <span>RM {parseFloat(receipt.campTransAmount || 0).toFixed(2)}</span>
          </div>

          <div className="receipt-actions">
            <button type="button" className="receipt-back-btn" onClick={() => navigate('/senarai-institusi')}>
              <i className="fas fa-arrow-left"></i>
              Kembali ke Senarai Institusi
            </button>
            <button type="button" className="receipt-print-btn" onClick={handlePrint}>
              <i className="fas fa-print"></i>
              Cetak Resit
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Receipt;
